import ActionMenu from "@/v2-backoffice-client/components/actionMenu"
import LicenseFeatureGroupUpsertMenuItem from "@/v2-backoffice-client/license/featureGroup/LicenseFeatureGroupUpsertMenuItem"
import LicenseFeatureGroupDeleteMenuItem from "@/v2-backoffice-client/license/featureGroup/LicenseFeatureGroupDeleteMenuItem"
import type { FeatureGroupFragment } from "@/v2-backoffice-client/license/featureGroup/__types__/license.featureGroup.fragment"

export type LicenseFeatureGroupTableRowToolbarProps = {
  featureGroup: FeatureGroupFragment
}

// Row actions on the feature-group board: identity edit and delete — both
// app-owned writes; nothing on this board is mirrored from anywhere. What
// the group bundles is managed on its panel (the row's name link), where
// the usage picture is in view.
function LicenseFeatureGroupTableRowToolbar(
  props: LicenseFeatureGroupTableRowToolbarProps,
) {
  const { featureGroup } = props

  return (
    <ActionMenu>
      <ActionMenu.Trigger />
      <ActionMenu.Content>
        <LicenseFeatureGroupUpsertMenuItem featureGroup={featureGroup} />

        <ActionMenu.Separator />
        <LicenseFeatureGroupDeleteMenuItem featureGroup={featureGroup} />
      </ActionMenu.Content>
    </ActionMenu>
  )
}

export default LicenseFeatureGroupTableRowToolbar
